import get from 'lodash/get';
import ReduxStore from '../../../ReduxStore';
import {htmlEncode} from 'js-htmlencode';
import format from 'dateformat';
import CoverImages from 'lib/CoverImages';
import {isEnabled} from 'api/reports/util/SectionUtils';
import { joinNonEmpties } from 'api/reports/util/StringUtils';
import {encodedUriWithoutResize} from 'api/reports/util/UriUtils';

const preparedText = (s) => {
  const encoded = (text) => {
    return text && htmlEncode(text.trim());
  };

  const onValue = isEnabled(s, 'preparedOn') ? encoded(get(s, 'sectionData.preparedOn', format(new Date(), 'dS mmmm yyyy'))) : undefined;
  const forValue = isEnabled(s, 'preparedFor') ? encoded(get(s, 'sectionData.preparedFor') || undefined) : undefined;

  if (forValue && onValue) {
    return `Prepared for <b>${forValue}</b> on <b>${onValue}</b>`;
  } else if (isEnabled(s, 'preparedOn')) {
    return `Prepared on <b>${onValue}</b>`;
  } else if (forValue) {
    return `Prepared for <b>${forValue}</b>`;
  }
  return undefined;
};

const makeCoverSection = (s) => {
  const {title} = get(s, 'sectionData') || {};
  const state = ReduxStore.getState();
  const {propertyDetail, userDetails, theme} = state;
  const agencyName = get(s, 'sectionData.agency') || userDetails.tradeName;
  const agentName = get(s, 'sectionData.agentName') || joinNonEmpties([userDetails.firstName, userDetails.lastName]);
  const mobile = get(s, 'sectionData.mobile') || userDetails.workMobileNumber;
  const landline = get(s, 'sectionData.landline') || userDetails.workPhoneNumber;
  const email = get(s, 'sectionData.email') || userDetails.workEmail;
  const agencyAddress = get(s, 'sectionData.agencyAddress') || joinNonEmpties([userDetails.address1, userDetails.address2]);
  const agencyAddress2 = get(s, 'sectionData.agencyAddress2') || joinNonEmpties([
    userDetails.suburb,
    userDetails.state,
    userDetails.postalCode,
  ]);
  const agentDetails = {
    agentName: isEnabled(s, 'agentName') ? agentName : '',
    tradeName: isEnabled(s, 'agency') ? agencyName : '',
    addressLine1: isEnabled(s, 'agencyAddress') ? agencyAddress : '',
    addressLine2: isEnabled(s, 'agencyAddress') ? agencyAddress2 : '',
    workMobileNumber: isEnabled(s, 'mobile') ? mobile && `m: ${mobile}` : '',
    workPhoneNumber: isEnabled(s, 'landline') ? landline && `w: ${landline}` : '',
    email: isEnabled(s, 'email') ? email : '',
    photo: isEnabled(s, 'agentPhoto') ? userDetails.photo : undefined,
  };

  const selectedImage = CoverImages.selectedImage(state);

  const template = 'signature/cma/2.0/cover-full';

  const imageUri = encodedUriWithoutResize(selectedImage.src);
  const cropCoverImage = CoverImages.shouldCropCoverImage(state);

  const imageZoom = selectedImage.zoom;
  const imageXOffset = selectedImage.x ?? 0;
  const imageYOffset = selectedImage.y ?? 0;

  return {
    name: 'COVER_PAGE',
    title: isEnabled(s, 'title') ? title : undefined,
    template,
    data: {
      agencyLogoUri: isEnabled(s, 'agencyLogo') ? encodedUriWithoutResize(userDetails.agencyLogoUri) : undefined,
      reportTitle: isEnabled(s, 'title') ? title : undefined,
      preparedText: preparedText(s),
      imageUri,
      imageXOffset,
      imageYOffset,
      imageZoom,
      cropCoverImage,
      singleLineAddress: isEnabled(s, 'singleLineAddress')
          ? get(s, 'sectionData.singleLineAddress') || propertyDetail.singleLineAddress
          : undefined,
      maxPages: 1,
      agentDetails,
      theme,
    }
  };
};
export default makeCoverSection;
